module.exports = __webpack_public_path__ + "static/media/starProduct4.72e3412e.png";